/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for All notifications;
 *   Integrations :
 *   Version : v1.0
 *   Created : 31-12-2021
*/
/*import packages*/
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'antd';

/*import components*/
import { Loader } from '../../components/loader';
import { Toast } from '../../components/note';

/*import assets*/

/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';


const Index = (props) => {
	const [notificationData, setNotificationData] = useState([]);
	const [error, setError] = useState(null);
	const [page, setPage] = useState(1);
	const [loader, setLoader] = useState(false);
	//eslint-disable-next-line
	const [count, setCount] = useState();
	let navigator = useNavigate();

	useEffect(() => {
		getNotificationCount();
		getNotification();
		//eslint-disable-next-line
	}, [page]);

	useEffect(() => {
		setTimeout(() => {
			setError(null)
		}, 3000);
	}, [error]);

	const getNotification = () => {
		setLoader(true);

		let url = devconfig.admin + '/notification/get-received-notification';

		let data = JSON.stringify({
			page_num: page
		});

		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				if (response.status === true) {
					setNotificationData(response.data);
					setLoader(false);
				} else {
					setLoader(false);
					setNotificationData([])
				}
			}
			else {
				setError(response.message);
				setNotificationData([])
				setLoader(false);
			}
		});
	}

	const getNotificationCount = () => {
		let url = devconfig.admin + '/notification/count';
		APIGet(url).then((response) => {
			if (response.status_code === 200) {
				setCount(response.data.notification_count);
			}
		})
	}

	/*---- read notification api----*/
	const ReadNotification = (id) => {
		let url = devconfig.admin + '/notifications/read';

		let data = JSON.stringify({
			notification_id: id,
		})
		APIPost(url, data).then((response) => {
			if (response.status_code === 200) {
				getNotification();
			} else {
				setError(response.message);
			}
		});
	}

	const redirectUser = (temp) => {
		switch (temp.type) {
			case 1: navigator(`/user-detail?id=${temp.data_id}`);
				break;
			case 2: navigator(`/user-detail?id=${temp.data_id}&tab=${2}`);
				break;
			default: navigator("/");
		}
	}

	return (
		<>
			<div className="row mt-4">
				<div className="col-md-12">

					<div className="card e-dashboard-card border-0 p-2 pb-3 e-holding-table">

						{/*--------------- notification list ------------*/}

						{
							loader === true ?
								<Loader />
								:
								notificationData.length > 0 ?
									<>
										{
											notificationData?.filter((data) => data.is_read === false).map((notData, key) => (
												<div
													className="row mt-3 p-2 e-notification-sec mx-3 mb-4"
													key={notData.notification_id}
													onClick={() => { ReadNotification(notData.notification_id); redirectUser(notData) }}>
													<h4 className="pt-3">{notData.title}</h4>
													<p className='pt-2'>{notData.description}</p>
												</div>
											))
										}
										{
											notificationData?.filter((data) => data.is_read === true).map((notData, key) => (
												<div className="row mt-3 p-2 e-notification-sub-sec mx-3" key={notData.notification_id} onClick={() => redirectUser(notData)}>
													<h4 className="pt-1">{notData.title}</h4>
													<p className='pt-2'>{notData.description}</p>
												</div>
											))
										}

									</>
									:
									<div className="row mt-3 p-2 e-notification-sec mx-3 my-5">
										<h6 className='text-center'>No notifications found</h6>
									</div>
						}
						<div align="center">
							<Pagination
								current={page}
								total={count}
								onChange={(current) => { setPage(current); }}
							/>
						</div>
					</div>
				</div>
			</div>

			{/*--------------- error message toast-------------*/}
			{
				error !== null ?
					<Toast
						data={error}
						type="fail"
						format={1}
					/>
					:
					null
			}
		</>
	);
}

export default Index;

